import styled from 'styled-components'

export const ScreenContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
`

export const ViptechLogoDiv = styled.div`
  display: flex;
  position: absolute;
  bottom: 2em;
  right: 2em;
`

export const LoginBox = styled.div`
  width: 532px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 36px;
  padding: 48px 56px;
  backdrop-filter: blur(16px);
  border-radius: 16px;
  box-shadow: ${({theme}) => `0px 4px 24px 0px ${theme.login.boxShadowColor}`};
  background: ${({theme}) => theme.login.backdropColor};

  @media (max-width: 500px) {
    padding: 20px 32px;
    gap: 20px;
    width: auto;
    min-width: 300px;
  }
`

export const TopDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  width: 100%;
`

export const Logo = styled.img`
  width: 200px;
`

export const MessageSpan = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: 2rem;
  line-height: 2.5rem;
  color: ${(props) => props.color};
  @media (max-width: 500px) {
    font-size: 1.5rem;
  }
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const InputDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Input = styled.input`
  font-size: 16px;
  color: #eaecf0;
  width: 100%;
  background-color: #344054;
  height: 52px;
  border-radius: 12px;
  border: none;
  text-indent: 4%;
  outline: 0;
  :focus {
    outline: none;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:hover {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: #eaecf0 !important;
    caret-color: #eaecf0;
  }
`
export const ButtonDiv = styled.div`
  width: 100%;
  margin-top: 32px;
`

export const Button = styled.button`
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid #004677;
  color: white;
  font-size: 19px;
  background-color: #009eff;
  width: 100%;
  height: 2em;
  transition: 0.4s;
  font-weight: bold;
  :hover {
    background-color: #00639f;
  }
  :disabled {
    opacity: 0.4;
    cursor: default;
    :hover {
      background-color: #009eff;
    }
  }
`

export const ContainerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 500px) {
    font-size: 14px;
  }
`

export const ContainerOptions = styled.div`
  color: white;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  @media (max-width: 500px) {
    font-size: 10px;
    margin-top: 10px;
    gap: 8px;
  }
`

export const LinkText = styled.span`
  color: white;
  font-size: 13.5px;
  text-decoration: underline;
  @media (max-width: 500px) {
    font-size: 10px;
  }
`

export const ContainerSSO = styled.div<{marginTop?: string}>`
  margin-top: ${(props) => props.marginTop};
  width: 100%;
`

export const SSOButton = styled.button`
  width: 100%;
  background: transparent;
  color: white;
  height: 47.5px;
  font-size: 18px;
  font-weight: bold;
  border: 1px solid #009eff;
  border-radius: 10px;
`

export const SxLoadingButtonLogin = {
  cursor: 'pointer',
  borderRadius: '10px',
  border: '1px solid #004677',
  color: 'white',
  fontSize: '19px',
  backgroundColor: '#009eff',
  width: '100%',
  height: '2.5em',
  transition: '0.4s',
  textTransform: 'none',
  fontWeight: 'bold',
  fontFamily: 'Inter',
  '&:hover': {
    backgroundColor: '#00639f',
  },
}

export const IncorrectUser = styled.label`
  font-family: 'Inter', sans-serif;
  color: tomato;
  font-size: 0.8rem;
  margin: 0.5em 0;
`
export const ListFeddback = styled.li`
  color: #f2f4f7;
`
export const CancelAndGoBackButton = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 400;
  box-shadow: none;
  text-transform: none;
  margin-right: 15px;
  background: transparent;
  border: 1px solid #98a2b3;
  color: #f2f4f7;

  :hover {
    background: #ffffff20;
  }
`
